import { oidcEarlyInit } from "oidc-spa/entrypoint";

// Must run before anything else: it consumes the login callback and decides whether to boot.
const early = oidcEarlyInit({ BASE_URL: "/" });

if (early.shouldLoadApp) {
  import("./main.lazy");
}
